let input = {
  filters: {
    phoneSecret(v, one = 3, two = 3, three = 2, four = 2) {
      v = v.toString().replace(/[^0-9]/g,'')

      if (v[0] == '7' || v[0] == '8') {
        v = v.slice(1)
      }

      let regx =  new RegExp(`(\\d{${one}})(\\d{${two}})(\\d{${three}})(\\d{${four}})`)
      return v ? v.toString().replace(regx, '+7 ($1) $2-**-**') : v
    },

    phoneType(v, one = 4, two = 2, three = 2, four = 2) {
      let regx =  new RegExp(`(\\d{${one}})(\\d{${two}})(\\d{${three}})(\\d{${four}})`)
      return v ? v.toString().replace(regx, '+7 ($1) $2-$3-$4') : v
    },

    phoneTel(v) {
      return v ? v.toString().replace(/[^0-9]/g,'') : v
    },

    price(v) {
      v = v.toString().replace('.', ',')
      return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  },

  methods: {
    getPhoneNumber(v) {
      return v ? v.toString().replace(/[^0-9]/g,'') : v
    }
  }
}

export default input
